import { FC } from 'react';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { TitleFieldCard } from './styled';
import { ITitleField } from '../../../../types';

interface OriginalTitleFieldProps {
  field: ITitleField;
}

export const OriginalTitleField: FC<OriginalTitleFieldProps> = ({ field }) => (
  <TitleFieldCard>
    <SText
      title={field.data}
      fontColor={TextColor.SlateGrey}
      weight="semibold"
    />
  </TitleFieldCard>
);
